<template>
      <div class="product-card p-1">
        <div class="cursor-pointer img-overlay" v-on:click="$emit('storeSelProduct', in_data, pos)">
            <img v-bind:src="in_data.product_images_url" :alt="in_data.product_name" min-height="200px" class="mx-auto d-block w-100 backgroundss">
        </div>   
        <section>
            <div class="row  p-2">
                <div class="col col-md-12" >
                    <div class="row product-cards-items">
                        <div class="col-9 col-md-9 p-0">
                            <span class="product-title"> {{in_data.product_name}}</span>
                                /
                            <span class="brand-title"> {{in_data.brand_name}}</span>
                        </div>
                        <div class="col-3 col-md-3 p-1  product-status text-danger text-right" >
                            {{in_data.product_status=='new' ? 'new' : ''}}
                        </div> 
                    </div>
                    <div class="row product-cards-items">
                        <div class="col-9 col-md-9 p-0 product-description" >
                            {{in_data.product_desc.substring(0,100)}} <span v-if="in_data.product_desc.length >= 100">...</span>
                            
                        </div>
                        <div class="col-3 col-md-3 p-1" > 
                                <a  class="addwatchlist text-right" v-on:click="$emit('addProductList', in_data, pos)" v-if="!in_data.selected"> 
                                    <span class="text-right">
                                        <img class="add-image" src="@/assets/Plus.png">
                                    </span>
                                </a>
                                   
                            <a class="removewatchlist" v-on:click="$emit('removeProductList', in_data, pos)" v-if="in_data.selected"> 
                                    <span class="text-right">
                                        <img class="add-image" src="@/assets/Cross.png">

                                    </span>
                            </a>
                        </div>
                    </div>
                </div> 
            </div> 
        </section>
    </div>
</template>
<script>
import Vue from 'vue'
   export default Vue.extend ({
    data(){
        return{
            show: true
        }
    },
    props: {
        in_data: Object,
        pos:Number
    },
    methods:{
        
    },

    created(){
        // console.log('is data for products',this.in_data)
    }
   
})
</script>

<style scoped>
/* .fade-enter-active, .fade-leave-active {
  transition: opacity .15s;
}
.fade-enter, .fade-leave-to / .fade-leave-active below version 2.1.8 / {
  opacity: 0;
} */
    .product-cards-items{
        margin-left: -9px !important;
        margin-right: -12px !important;
        font-family: 'Barlow', sans-serif;
    }
    .product-title{
        /* font-size: small; */
        /* color: #000000; */
        font-size: small;
        color:#000000;
        font-weight: 400 !important;
        text-transform: uppercase;
    }
    .brand-title{
        font-size: small;
        font-weight: 400 !important;
        color: #858585;
        text-transform: uppercase;
    }
    .product-description {
        font-family: 'Barlow', sans-serif;
        text-transform: inherit;
        font-size: x-small;
        /* font-weight:400; */
        color:#858585;
    }
    .product-status{
        font-family: 'Barlow', sans-serif;
        text-transform: uppercase;
        font-size: x-small;
        color:red;
    }
    
    .product-details{
        padding-left: 0px;
        padding-right: 0px;
    }
    .add-button{
        border: 1px solid gray;
    }
    .btn{
        /* padding: 0.0rem .5rem; */
        padding: 0px 7px !important;
    }
    .add-image{
        width: 24px !important;
        background: white;
    }
    .addwatchlist{
        cursor: pointer;
    }
   .removewatchlist{
       cursor: pointer;
   }
   .owl-carousel .owl-item img{
        width: 30%;
        background: white;
        float:right
   }
   .backgroundss{
       /* background-image:url('../../assets/Logos/Actiu.png'); */
       width:100% !important;
       min-height: 330px !important;
       background:#f2f2f2 !important;

   }
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
 /* img:hover {
        transform: scale(1.0);
        opacity: 0.5;
 }

 .img-overlay:hover{
     transform: scale(1.05);
     background: #333333;
 } */
.product-card  {

    -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadein 2s; /* Firefox < 16 */
        -ms-animation: fadein 2s; /* Internet Explorer */
         -o-animation: fadein 2s; /* Opera < 12.1 */
            animation: fadein 4s;
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Internet Explorer */
@-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
</style>